import { ApiProperty } from '@nestjs/swagger';
import { IsUUID } from 'class-validator';

export class AddChapterToPathDto {
  @ApiProperty({ description: 'ID du chapitre à lier au parcours' })
  @IsUUID()
  chapterId!: string;
}

